import { MetaConfigItem } from '@/lowcode/common/types';
import { CnRankingLowCodeRequestConfig, CnRankingProps } from './types';

const getDataConfig = (configItem?: MetaConfigItem) =>
  configItem?.records?.map((record) => ({
    title: record.settings?.aliasName || record.name,
    dataIndex: record.name,
    ...record.settings,
  })) || [];

export const getConfigFromLowCode = (
  requestConfig?: CnRankingLowCodeRequestConfig,
): Partial<
  Pick<CnRankingProps<Record<string, unknown>>, 'rankingDimension' | 'rankingMeasures'>
> => {
  if (!requestConfig?.metaConfig) {
    return {
      rankingDimension: undefined,
      rankingMeasures: [],
    };
  }

  // 排名维度
  const rankingDimension = getDataConfig(requestConfig.metaConfig?.rankingDimension);

  // 排名指标
  const rankingMeasures = getDataConfig(requestConfig.metaConfig?.rankingMeasures);
  // 辅助指标，展示辅助数据，不参与排序
  const auxiliaryMeasure = getDataConfig(requestConfig.metaConfig?.auxiliaryMeasures);

  return {
    rankingDimension: rankingDimension?.[0],
    // 只在有主指标时展示排名，否则不展示
    rankingMeasures: rankingMeasures.length > 0 ? rankingMeasures.concat(auxiliaryMeasure) : [],
  };
};
